import { css } from '@emotion/react';
import { IText } from '@types';
import { PropsWithChildren } from 'react';
import { Row, Col, Space, Content, colors, Text } from 'common-components';
import DataLengthTag from './DataLengthTag';

interface ITablePageHeader {
  count: number
  texts: IText[]
}

const TableCardHeader = function ({
  count,
  texts,
  children,
}: PropsWithChildren<ITablePageHeader>) {
  return (
    <Content>
      <Row
        justify={'space-between'}
        align={'top'}
        css={css`
          border: 1px solid ${colors.gray200};
          border-bottom: none;
          border-radius: 12px 12px 0 0;
          padding: 20px 24px;
          margin-top: 20px;
          align-items: center;
        `}
      >
        <Col>
          {texts.map((text) => (
            <div key={text.content}
              css={css`
                display: flex;
                gap: 8px;
                align-items: center;
              `}
            >
              <Text size="lg" color={colors.gray900} style={{ fontWeight: 500 }}>
                {text.content}
              </Text>
              <DataLengthTag>{count}</DataLengthTag>
            </div>
          ))}
        </Col>
        <Row>
          <Space>{children}</Space>
        </Row>
      </Row>
    </Content>
  );
};

export default TableCardHeader;
